module.exports = __webpack_public_path__ + "img/logo_天哲.b820b729.png";